<!-- ******* ADMIN STEMD *********-->
<div *ngIf="isStemd" class="nav_container">
  <ul>
    <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Formation
      </li>
      <li>
        <a [routerLink]="['stemd/stemd-list-cours']" class="nav_item" routerLinkActive="active-link">
          <svg style="transform: scale(1.4); margin-right: 8px">
            <path
              d="M17.8536 4.35355C18.0488 4.15829 18.0488 3.84171 17.8536 3.64645C17.6583 3.45118 17.3417 3.45118 17.1464 3.64645L15.5 5.29289L14.8536 4.64645C14.6583 4.45118 14.3417 4.45118 14.1464 4.64645C13.9512 4.84171 13.9512 5.15829 14.1464 5.35355L15.1464 6.35355C15.3417 6.54882 15.6583 6.54882 15.8536 6.35355L17.8536 4.35355ZM2.5 5C2.22386 5 2 5.22386 2 5.5C2 5.77614 2.22386 6 2.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H2.5ZM2.5 10C2.22386 10 2 10.2239 2 10.5C2 10.7761 2.22386 11 2.5 11H11.5C11.7761 11 12 10.7761 12 10.5C12 10.2239 11.7761 10 11.5 10H2.5ZM2 15.5C2 15.2239 2.22386 15 2.5 15H11.5C11.7761 15 12 15.2239 12 15.5C12 15.7761 11.7761 16 11.5 16H2.5C2.22386 16 2 15.7761 2 15.5ZM17.8536 9.85355C18.0488 9.65829 18.0488 9.34171 17.8536 9.14645C17.6583 8.95118 17.3417 8.95118 17.1464 9.14645L15.5 10.7929L14.8536 10.1464C14.6583 9.95118 14.3417 9.95118 14.1464 10.1464C13.9512 10.3417 13.9512 10.6583 14.1464 10.8536L15.1464 11.8536C15.3417 12.0488 15.6583 12.0488 15.8536 11.8536L17.8536 9.85355ZM17.8536 14.1464C18.0488 14.3417 18.0488 14.6583 17.8536 14.8536L15.8536 16.8536C15.6583 17.0488 15.3417 17.0488 15.1464 16.8536L14.1464 15.8536C13.9512 15.6583 13.9512 15.3417 14.1464 15.1464C14.3417 14.9512 14.6583 14.9512 14.8536 15.1464L15.5 15.7929L17.1464 14.1464C17.3417 13.9512 17.6583 13.9512 17.8536 14.1464Z"
              fill="#E5E8EC" />
          </svg>
          <span class="ml-2">Liste des cours</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['stemd/stemd-apprenants-stemd']" class="nav_item" routerLinkActive="active-link">
          <svg style="transform: scale(1.2); margin-right: 8px">
            <path
              d="M11 10C12.1046 10 13 10.8954 13 12H12.5C12.3247 12 12.1564 12.0301 12 12.0854V12C12 11.4477 11.5523 11 11 11H4C3.44772 11 3 11.4477 3 12V13.5C3 14.9071 4.57862 16 7.5 16C9.06314 16 10.2419 15.6871 11 15.1806V16.3174C10.0958 16.7527 8.91115 17 7.5 17C4.08805 17 2 15.5544 2 13.5V12C2 10.8954 2.89543 10 4 10H11ZM17.5 12C17.6753 12 17.8436 12.0301 18 12.0854V12C18 10.8954 17.1046 10 16 10L13.2353 9.99912C13.4937 10.2876 13.6971 10.6265 13.829 10.9991L16 11C16.5523 11 17 11.4477 17 12H17.5ZM7.5 2C9.433 2 11 3.567 11 5.5C11 7.433 9.433 9 7.5 9C5.567 9 4 7.433 4 5.5C4 3.567 5.567 2 7.5 2ZM7.5 3C6.11929 3 5 4.11929 5 5.5C5 6.88071 6.11929 8 7.5 8C8.88071 8 10 6.88071 10 5.5C10 4.11929 8.88071 3 7.5 3ZM14.5 4C15.8807 4 17 5.11929 17 6.5C17 7.88071 15.8807 9 14.5 9C13.1193 9 12 7.88071 12 6.5C12 5.11929 13.1193 4 14.5 4ZM14.5 5C13.6716 5 13 5.67157 13 6.5C13 7.32843 13.6716 8 14.5 8C15.3284 8 16 7.32843 16 6.5C16 5.67157 15.3284 5 14.5 5ZM12.5 13C12.2239 13 12 13.2239 12 13.5C12 13.7761 12.2239 14 12.5 14H17.5C17.7761 14 18 13.7761 18 13.5C18 13.2239 17.7761 13 17.5 13H12.5ZM12.5 15C12.2239 15 12 15.2239 12 15.5C12 15.7761 12.2239 16 12.5 16H17.5C17.7761 16 18 15.7761 18 15.5C18 15.2239 17.7761 15 17.5 15H12.5ZM12.5 17C12.2239 17 12 17.2239 12 17.5C12 17.7761 12.2239 18 12.5 18H17.5C17.7761 18 18 17.7761 18 17.5C18 17.2239 17.7761 17 17.5 17H12.5Z"
              fill="#E5E8EC" />
          </svg>
          <span class="ml-2">Liste des élèves</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['stemd/etudiants']" class="nav_item" routerLinkActive="active-link">
          <svg style="margin-right: 8px" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="users-02">
              <path id="Icon"
                d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
                stroke="#E5E8EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
          </svg>
          <span class="ml-2">Gestion des étudiants</span>
        </a>
      </li>
    </div>
  </ul>
</div>
<div *ngIf="isFcc || isSEV || isBoard" class="nav_container">
  <ul>
    <div class="mb-4">
      <!-- ********** SIGUI ******* -->
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">Sigui</li>
      <!-- <li *ngIf="!isSEV">
        <a [routerLink]="['application-simplify/listwebinaire']" class="nav_item"
          style="padding-top: 3px; padding-bottom: 3px" routerLinkActive="active-link">
          <svg style="margin-left: -5px; width: 28px; height: 28px;" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 10L19 7V17L15 14V17C15 18.1046 14.1046 19 13 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H13C14.1046 5 15 5.89543 15 7V10Z"
              stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="9" cy="11" r="2" stroke="#E5E8EC" stroke-width="1.5" />
          </svg>
          <span style="margin-left: 5px">Participants webinaire</span>
        </a>
      </li> -->
      <li *ngIf="!isSEV">
        <a [routerLink]="['appels/sigui-certificat']" class="nav_item" routerLinkActive="active-link">
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" style="fill: #e5e8ec">
            <g id="Setting">
              <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                d="M4,12H8.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2H25.941A8.9963,8.9963,0,0,0,8.059,10H4a1,1,0,0,0,0,2ZM17,4a7,7,0,1,1-7,7A7.0085,7.0085,0,0,1,17,4Z" />
              <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                d="M60,31H55.941a8.9963,8.9963,0,0,0-17.882,0H4a1,1,0,0,0,0,2H38.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2ZM47,39a7,7,0,1,1,7-7A7.0085,7.0085,0,0,1,47,39Z" />
              <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                d="M60,52H33.941a8.9963,8.9963,0,0,0-17.882,0H4a1,1,0,0,0,0,2H16.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2ZM25,60a7,7,0,1,1,7-7A7.0085,7.0085,0,0,1,25,60Z" />
            </g>
          </svg>
          <span class="ml-3">Gestion des Certificats</span>
        </a>
      </li>
      <li *ngIf="!isSEV">
        <a [routerLink]="['appels/listAppels']" class="nav_item" routerLinkActive="active-link">
          <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"
            style="width: 28px; height: 22px; margin-left: -4px">
            <rect fill="none" />
            <path d="M159.4,40A80.1,80.1,0,0,1,216,96.6" fill="none" stroke="#F3F4F6" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="8" />
            <path d="M151.1,70.9a47.9,47.9,0,0,1,34,34" fill="none" stroke="#fff" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="8" />
            <path
              d="M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z"
              fill="none" stroke="#F3F4F6" stroke-linecap="round" stroke-linejoin="round" stroke-width="12" />
          </svg>
          <span class="ml-2">Gestion des Appels</span>
        </a>
      </li>
      <li>
        <button (click)="toggleCollapse(1)" class="toggle-button bg-transparent pr-5">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="none" stroke="#E5E8EC" stroke-width="30"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
          </svg>
          Sessions SIGUI
          <i [class.pi]="true" [class.pi-chevron-down]="sections[0].isCollapsed"
            [class.pi-chevron-up]="!sections[0].isCollapsed" style="margin-left: auto"></i>
        </button>
        <div [@slideToggle]="sections[0].isCollapsed ? 'closed' : 'open'" class="animated-paragraph"
          style="margin-left: 8px">
          <ul>
            <li *ngFor="let family of listFamily">
              <ng-container *ngIf="family.shortName">
                <div (click)="toggleOfftrack(family)" class="nav_item cursor-pointer flex items-center py-1">
                  <i [class]="
                      family.isCollapsed
                        ? 'pi pi-chevron-right'
                        : 'pi pi-chevron-down'
                    " class="text-xs ms-2 text-white"></i>
                  <span class="ms-2 text-sm font-bold uppercase text-white">{{
                    family.shortName
                    }}</span>
                </div>

                <ul *ngIf="!family.isCollapsed">
                  <li *ngFor="let cohorteName of family.cohorteNames">
                    <a class="nav_item flex items-center py-1 cursor-pointer" routerLinkActive="active-link"
                      (click)="sessionChange(cohorteName)">
                      <i class="pi pi-chevron-right text-xs ms-4"></i>
                      <span class="ms-2 text-xs">{{ cohorteName }}</span>
                    </a>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </li>

      <!-- *********************** Sessions hORS sigui DEBUT ********************* -->
      <li>
        <button (click)="toggleCollapse(3)" class="toggle-button bg-transparent pr-5">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="none" stroke="#E5E8EC" stroke-width="30"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
          </svg>
          Sessions Hors SIGUI
          <i [class.pi]="true" [class.pi-chevron-down]="sections[2].isCollapsed"
            [class.pi-chevron-up]="!sections[2].isCollapsed" style="margin-left: auto"></i>
        </button>
        <div [@slideToggle]="sections[2].isCollapsed ? 'closed' : 'open'" class="animated-paragraph"
          style="margin-left: 8px">
          <ul>
            <li *ngFor="let offtract of listofftrack">
              <div (click)="toggleOfftrack(offtract)" class="nav_item cursor-pointer flex items-center py-1">
                <i [class]="
                    offtract.isCollapsed
                      ? 'pi pi-chevron-right'
                      : 'pi pi-chevron-down'
                  " class="text-xs ms-2 text-white"></i>
                <span class="ms-2 text-sm font-bold uppercase text-white">{{
                  offtract.name
                  }}</span>
              </div>
              <ul *ngIf="!offtract.isCollapsed">
                <li *ngFor="let cohorteName of offtract.cohorteNames">
                  <a class="nav_item flex items-center py-1 cursor-pointer" routerLinkActive="active-link"
                    (click)="sessionChangeHparcours(cohorteName)">
                    <i class="pi pi-chevron-right text-xs ms-4"></i>
                    <span class="ms-2 text-xs">{{ cohorteName }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
      <!-- ********************** Sessions hORS sigui fin *************************** -->
      <!-- Soft Skills -->
      <li *ngIf="isFcc">
        <a routerLink="softskills/liste" class="nav_item" routerLinkActive="active-link">
          <svg height="32" id="icon" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
            <defs></defs>
            <path d="M30,30H22V4h8Zm-6-2h4V6H24Z" fill="#E5E8EC" />
            <path d="M20,30H12V12h8Z" fill="#E5E8EC" />
            <path d="M10,30H2V18h8Z" fill="#E5E8EC" />
            <rect style="fill: none; color: #e5e8ec" data-name="&lt;Transparent Rectangle&gt;" height="32"
              id="_Transparent_Rectangle_" width="32" />
          </svg>
          <span class="ml-3">Gestion des Soft Skills</span>
        </a>
      </li>
    </div>
  </ul>
</div>
<!-- ********************** MENTORAT *************************** -->
<div *ngIf="isFcc" class="nav_container ml-1">
  <div class="mb-4">
    <ul>
      <li class="uppercase text-greyLighter text-sm font-bold mb-2">
        Mentorat
      </li>
      <li class="mb-2">
        <a [routerLink]="['users/list-mentors']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
          routerLinkActive="active-link">
          <svg style="margin-left: -5px; width: 22px; height: 22px" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <!-- Icône de documents/candidatures (contour) -->
            <path stroke="#F3F4F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              d="M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6z" />
            <path stroke="#F3F4F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              d="M14 2v6h6M8 15h8M8 11h8M8 7h5" />
          </svg>
          <span style="margin-left: 10px">Gestion Candidatures</span>
        </a>
      </li>
      <!-- <li class="mb-1">
        <a
          [routerLink]="['mentorat/planning-course']"
          class="nav_item"
          style="padding-top: 3px; padding-bottom: 3px"
          routerLinkActive="active-link"
        >
          <svg
            style="margin-left: -5px; width: 22px; height: 22px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3"
              y="4"
              width="18"
              height="18"
              rx="2"
              stroke="#F3F4F6"
              stroke-width="1.5"
            />
            <path
              stroke="#F3F4F6"
              stroke-width="1.5"
              stroke-linecap="round"
              d="M3 10h18M8 2v4M16 2v4"
            />
            <rect
              x="7"
              y="12"
              width="4"
              height="4"
              stroke="#F3F4F6"
              stroke-width="1.5"
            />
          </svg>
          <span style="margin-left: 10px">Emploie du temps</span>
        </a>
      </li> -->
      <li>
        <a [routerLink]="['mentorat/groupe']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <!-- Icône de groupe de personnes -->
            <path fill="currentColor"
              d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
          <span class="ml-3">Gestion Groupes</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/gestionmentor']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <!-- Icône de groupe de personnes -->
            <path fill="currentColor"
              d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
          <span class="ml-3">Gestion Mentors</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/paiement']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="margin-left: -5px; width: 24px; height: 24px" viewBox="0 0 24 24" fill="none" stroke="#ffffff"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
            <line x1="3" y1="11" x2="21" y2="11" />
            <line x1="7" y1="15" x2="9" y2="15" />
            <circle cx="18" cy="7" r="3" />
            <path d="M16.5 7.5l1 1 2-2" />
          </svg>
          <span class="ml-3">Gestion Paiements</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['mentorat/lesemploisdutemps']" class="nav_item" routerLinkActive="active-link">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="#E5E8EC" stroke="black" stroke-width="6"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
          </svg>
          <span class="ml-3">Les emplois du temps</span>
        </a>
      </li>
    </ul>
  </div>
</div>
<div class="nav_container">
  <ul>
    <div class="mb-4">
      <!-- Outils -->
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">Outils</li>
      <li>
        <a [routerLink]="['agenda/gestionnaire']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="#E5E8EC" stroke="black" stroke-width="6"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
          </svg>
          <span class="ml-3">Mon Agenda</span>
        </a>
      </li>
      <li>
        <a class="nav_item" routerLinkActive="active-link" [routerLink]="['agenda']"
          [routerLinkActiveOptions]="{ exact: true }" style="padding-left: 11px">
          <svg style="width: 24px; height: 22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="message-dots-circle">
              <path id="Icon"
                d="M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z"
                stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
          </svg>
          <span class="ml-2">Activités</span>
        </a>
      </li>
      <li *ngIf="!isFinance">
        <a [routerLink]="['cms']" class="nav_item" routerLinkActive="active-link" style="padding-left: 10px">
          <svg style="width: 24px; height: 22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="list">
              <path id="Icon"
                d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
                stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
          </svg>
          <span class="ml-2">CMS</span>
        </a>
      </li>
      <li *ngIf="isAipen || isFinance || profil == 4">
        <a [routerLink]="['documents']" class="nav_item" routerLinkActive="active-link">
          <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M10 16.5c0-1-8-2.7-9-2V1.8c1-1 9 .707 9 1.706M10 16.5V3.506M10 16.5c0-1 8-2.7 9-2V1.8c-1-1-9 .707-9 1.706" />
          </svg>
          <span class="ml-3">Mes documents</span>
        </a>
      </li>

      <!-- AMI -->
      <!-- enlever STEMD ET METTRE isCompany -->
      <ng-container *ngIf="isAipen || isFinance">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">AMI</li>
      </ng-container>
      <ng-container *ngIf="isAipen">
        <li>
          <a [routerLink]="['ami/enrolement']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"
              class="ng-tns-c3167694924-15">
              <!-- Cercle autour -->
              <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5" fill="none" />
              <!-- Croix au centre -->
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M10 4v12M4 10h12" class="ng-tns-c3167694924-15" />
            </svg>
            <span class="ml-3">Enrôlement</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['ami/generationliste']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }" style="padding-left: 8px">
            <svg version="1.1" viewBox="0 0 18.6 12.9" style="width: 28px; height: 22px" class="ng-tns-c1295285070-22">
              <g class="ng-tns-c1295285070-22">
                <g id="Calque_1" class="ng-tns-c1295285070-22">
                  <path fill="#F3F4F6"
                    d="M2,.9c-.6,0-1.1.5-1.1,1.1v7.7c0,.6.5,1.1,1.1,1.1h8.9c.1,0,.3-.1.3-.3h0c0-.1-.1-.3-.3-.3H2c-.3,0-.6-.3-.6-.6v-4.6h13v.3c0,.1.1.3.3.3h0c.1,0,.3-.1.3-.3,0,0,0,0,0,0V2c0-.6-.5-1.1-1.1-1.1H2ZM2,1.4h11.8c.3,0,.6.3.6.6v1.2H1.4v-1.2c0-.3.3-.6.6-.6ZM1.4,3.7h13v.8H1.4v-.8ZM14.6,6.1c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2,3.2-1.4,3.2-3.2-1.4-3.2-3.2-3.2ZM14.6,6.6c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7ZM2.9,7.1c-.1,0-.3.1-.3.3v1.6c0,.1.1.3.3.3h2.4c.1,0,.3-.1.3-.3v-1.6c0-.1-.1-.3-.3-.3h-2.4ZM3.1,7.6h1.8v1h-1.8v-1ZM15.8,8.2c0,0-.1,0-.2,0l-1.4,1.4-.7-.7c-.1-.1-.3-.1-.4,0,0,0,0,0,0,0-.1.1-.1.3,0,.4,0,0,0,0,0,0l.9.9c.1.1.3.1.4,0,0,0,0,0,0,0l1.6-1.6c.1-.1,0-.3,0-.4,0,0,0,0,0,0,0,0-.1,0-.2,0h0Z"
                    class="ng-tns-c1295285070-22"></path>
                </g>
              </g>
            </svg>

            <span class="ml-2 line-height-2">Génération liste de paiement</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['ami/listecompany']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 110 109.9"
              style="width: 22px; height: 22px">
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <path fill="#F3F4F6"
                    d="M34.2,10.1c.6-.6,1.3-.9,2.1-.9h47.5c5.6,0,10.2,4.6,10.2,10.2v73.2c0,5.6-4.6,10.2-10.2,10.2H26.2c-5.6,0-10.2-4.6-10.2-10.2V29.5l.5-1.6,17.7-17.8ZM37.1,51.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM45,85.1h19.9c3.9,0,3.9-6,0-6h-19.9c-3.9,0-3.9,6,0,6ZM37.1,68.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM22,32.5v60.1c0,2.3,1.9,4.2,4.2,4.2h57.6c2.3,0,4.2-1.9,4.2-4.2V19.4c0-2.3-1.9-4.2-4.2-4.2h-44.5v14.3c0,1.7-1.3,3-3,3h-14.3ZM33.3,26.5v-7l-7,7h7Z" />
                </g>
              </g>
            </svg>

            <span class="ml-2">Liste des documents</span>
          </a>
        </li>
      </ng-container>
      <ng-container *ngIf="isFinance">
        <li>
          <a [routerLink]="['ami/paiementetat']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }" style="padding-left: 8px">
            <svg version="1.1" viewBox="0 0 18.6 12.9" style="width: 28px; height: 22px">
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <path fill="#F3F4F6"
                    d="M2,.9c-.6,0-1.1.5-1.1,1.1v7.7c0,.6.5,1.1,1.1,1.1h8.9c.1,0,.3-.1.3-.3h0c0-.1-.1-.3-.3-.3H2c-.3,0-.6-.3-.6-.6v-4.6h13v.3c0,.1.1.3.3.3h0c.1,0,.3-.1.3-.3,0,0,0,0,0,0V2c0-.6-.5-1.1-1.1-1.1H2ZM2,1.4h11.8c.3,0,.6.3.6.6v1.2H1.4v-1.2c0-.3.3-.6.6-.6ZM1.4,3.7h13v.8H1.4v-.8ZM14.6,6.1c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2,3.2-1.4,3.2-3.2-1.4-3.2-3.2-3.2ZM14.6,6.6c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7ZM2.9,7.1c-.1,0-.3.1-.3.3v1.6c0,.1.1.3.3.3h2.4c.1,0,.3-.1.3-.3v-1.6c0-.1-.1-.3-.3-.3h-2.4ZM3.1,7.6h1.8v1h-1.8v-1ZM15.8,8.2c0,0-.1,0-.2,0l-1.4,1.4-.7-.7c-.1-.1-.3-.1-.4,0,0,0,0,0,0,0-.1.1-.1.3,0,.4,0,0,0,0,0,0l.9.9c.1.1.3.1.4,0,0,0,0,0,0,0l1.6-1.6c.1-.1,0-.3,0-.4,0,0,0,0,0,0,0,0-.1,0-.2,0h0Z" />
                </g>
              </g>
            </svg>
            <span class="ml-2"> Paiement des États</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['ami/listecompany']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 110 109.9"
              style="width: 22px; height: 22px">
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <path fill="#F3F4F6"
                    d="M34.2,10.1c.6-.6,1.3-.9,2.1-.9h47.5c5.6,0,10.2,4.6,10.2,10.2v73.2c0,5.6-4.6,10.2-10.2,10.2H26.2c-5.6,0-10.2-4.6-10.2-10.2V29.5l.5-1.6,17.7-17.8ZM37.1,51.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM45,85.1h19.9c3.9,0,3.9-6,0-6h-19.9c-3.9,0-3.9,6,0,6ZM37.1,68.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM22,32.5v60.1c0,2.3,1.9,4.2,4.2,4.2h57.6c2.3,0,4.2-1.9,4.2-4.2V19.4c0-2.3-1.9-4.2-4.2-4.2h-44.5v14.3c0,1.7-1.3,3-3,3h-14.3ZM33.3,26.5v-7l-7,7h7Z" />
                </g>
              </g>
            </svg>

            <span class="ml-2">Liste des documents</span>
          </a>
        </li>
      </ng-container>
      <!-- Mentorat Finance -->
      <ng-container *ngIf="isFinance" class="nav_container ml-1">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Mentorat
        </li>
        <div class="mb-4">
          <ul>
            <li>
              <a [routerLink]="['mentorat/paiement']" class="nav_item" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">
                <svg style="margin-left: -5px; width: 24px; height: 24px" viewBox="0 0 24 24" fill="none"
                  stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
                  <line x1="3" y1="11" x2="21" y2="11" />
                  <line x1="7" y1="15" x2="9" y2="15" />
                  <circle cx="18" cy="7" r="3" />
                  <path d="M16.5 7.5l1 1 2-2" />
                </svg>
                <span class="ml-3">Gestion Paiements</span>
              </a>
            </li>
          </ul>
        </div>
      </ng-container>

      <!-- Gestion Finance entre Partenanire -->
      <ng-container *ngIf="isFinance" class="nav_container ml-1">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          demandes de paiements
        </li>
        <div class="mb-4">
          <ul>
            <li>
              <a [routerLink]="['gestion-finance/dossier-partenaire']" class="nav_item" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">
                <svg style="margin-left: -5px; width: 24px; height: 24px" viewBox="0 0 24 24" fill="none"
                  stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
                  <line x1="3" y1="11" x2="21" y2="11" />
                  <line x1="7" y1="15" x2="9" y2="15" />
                  <circle cx="18" cy="7" r="3" />
                  <path d="M16.5 7.5l1 1 2-2" />
                </svg>
                <span class="ml-3">Gestion Documents</span>
              </a>
            </li>
          </ul>
        </div>
      </ng-container>
      <ng-container>
        <li class="uppercase text-greyLighter text-sm font-bold mb-1 mt-3">
          Accompagnement
        </li>
      </ng-container>
      <ng-container>
        <li>
          <a class="nav_item" style="cursor:pointer" (click)="showIframe = true">
            <svg height="24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Porte -->
              <path d="M4 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4V3z" fill="#E5E8EC" />

              <!-- Flèche connexion -->
              <path d="M13 12h7m0 0l-3-3m3 3l-3 3" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <span class="ml-3">Connexion</span>
          </a>
        </li>
        <li *ngIf="isAipen || isFcc">
          <a class="nav_item" [href]="urlClasseVirtuelle" target="_blank">
            <svg height="24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Écran -->
              <rect x="3" y="4" width="18" height="12" rx="2" fill="#E5E8EC" />

              <!-- Pied de l'écran -->
              <rect x="9" y="18" width="6" height="2" fill="#E5E8EC" />

              <!-- Tête utilisateur -->
              <circle cx="12" cy="9" r="2" fill="#FFFFFF" />

              <!-- Corps utilisateur -->
              <path d="M8 14c0-2 2-3 4-3s4 1 4 3" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" />

              <!-- Petit indicateur live -->
              <circle cx="19" cy="6" r="2" fill="#4CAF50" />
            </svg>

            <span class="ml-3">Classe Virtuelle</span>
          </a>
        </li>
      </ng-container>
    </div>
    <!-- PLATEFORME LMS -->
    <!-- Scholar Vox -->
    <!-- <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Plateforme LMS
      </li>
      <div>
        <ul>
          <li>
            <button class="nav_item text-left" (click)="openUrl(urlScholarVox)">
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(1.1)">
                <path fill="#E5E8EC"
                  d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z" />
              </svg>
              <span>Scholar Vox</span>
            </button>
          </li>
        </ul>
      </div>
    </div> -->
    <!-- PLATEFORME LMS -->
    <!-- Scholar Vox -->
  </ul>
</div>
<app-iframe-modal *ngIf="showIframe" [iframeUrl]="urlFondAmorcage" (closed)="showIframe = false" />